import { render, staticRenderFns } from "./MobileAppBanner.vue?vue&type=template&id=39e95032&scoped=true&"
import script from "./MobileAppBanner.vue?vue&type=script&lang=ts&"
export * from "./MobileAppBanner.vue?vue&type=script&lang=ts&"
import style0 from "./MobileAppBanner.vue?vue&type=style&index=0&id=39e95032&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39e95032",
  null
  
)

export default component.exports